(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'react', 'prop-types', '../svg/Eye', '../svg/EyeSlash'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('react'), require('prop-types'), require('../svg/Eye'), require('../svg/EyeSlash'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react, global.propTypes, global.Eye, global.EyeSlash);
    global.EyeIcon = mod.exports;
  }
})(this, function (exports, _react, _propTypes, _Eye, _EyeSlash) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _react2 = _interopRequireDefault(_react);

  var _propTypes2 = _interopRequireDefault(_propTypes);

  var _Eye2 = _interopRequireDefault(_Eye);

  var _EyeSlash2 = _interopRequireDefault(_EyeSlash);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  // FIXME may want to delete this component
  var EyeIcon = function EyeIcon(_ref) {
    var isPasswordVisible = _ref.isPasswordVisible,
        togglePasswordVisibility = _ref.togglePasswordVisibility;
    return _react2.default.createElement(
      'div',
      { onClick: togglePasswordVisibility },
      isPasswordVisible ? _react2.default.createElement(_EyeSlash2.default, null) : _react2.default.createElement(_Eye2.default, null)
    );
  };

  exports.default = EyeIcon;


  EyeIcon.propTypes = {
    isPasswordVisible: _propTypes2.default.bool,
    togglePasswordVisibility: _propTypes2.default.func
  };
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/elements/EyeIcon.js
// module id = 822
// module chunks = 1